export default __webpack_public_path__ + "static/media/coming-soon.b905f26e.png";